import React from 'react'
import { useTranslation } from 'react-i18next'

import Script from 'dangerous-html/react'
import LanguageSwitcher from './LanguageSwitcher'

import './navigation.css'

const Navigation = (props) => {
  const { t } = useTranslation('common')
  return (
    <div className="navigation-container1">
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation">
(function(){
  const navigationToggle = document.getElementById("navigation-toggle")
  const navigation = document.getElementById("navigation")
  const navigationMenu = document.getElementById("navigation-menu")

  navigationToggle.addEventListener("click", function () {
    navigation.classList.toggle("menu-open")
  })

  // Close menu when clicking on menu links (mobile)
  const navigationLinks = navigationMenu.querySelectorAll(".navigation-link")
  navigationLinks.forEach((link) => {
    link.addEventListener("click", function () {
      navigation.classList.remove("menu-open")
    })
  })

  // Close menu when clicking outside (mobile)
  document.addEventListener("click", function (event) {
    if (navigation.classList.contains("menu-open")) {
      const isClickInsideNav = navigation.contains(event.target)
      if (!isClickInsideNav) {
        navigation.classList.remove("menu-open")
      }
    }
  })

  // Handle scroll behavior for navigation background
  let lastScrollTop = 0
  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (scrollTop > 20) {
      navigation.style.background =
        "color-mix(in srgb, var(--color-surface) 98%, transparent)"
      navigation.style.borderBottomColor =
        "color-mix(in srgb, var(--color-border) 50%, transparent)"
    } else {
      navigation.style.background =
        "color-mix(in srgb, var(--color-surface) 95%, transparent)"
      navigation.style.borderBottomColor =
        "color-mix(in srgb, var(--color-border) 30%, transparent)"
    }

    lastScrollTop = scrollTop
  })

  // Update cart badge (example functionality)
  function updateCartBadge(count) {
    const cartBadge = document.getElementById("cart-badge")
    cartBadge.textContent = count
    cartBadge.style.display = count > 0 ? "flex" : "none"
  }

  // Initialize cart badge as hidden
  updateCartBadge(0)
})()
</script>`}
          ></Script>
        </div>
      </div>
      <nav id="navigation" aria-label="Main Navigation" className="navigation">
        <div className="navigation-container">
          <div className="navigation-brand">
            <a href="/" className="navigation-brand-link">
              <span className="navigation-brand-mark" aria-hidden="true">
                <img src="/favicon.jpeg" alt="" />
              </span>
              <div className="navigation-brand-copy">
                <div className="navigation-logo-row">
                  <span className="navigation-logo-text">ORRAM</span>
                  <span className="navigation-logo-accent">Frames</span>
                </div>
                <span className="navigation-logo-byline">by Sasha de saint Tropez</span>
              </div>
            </a>
          </div>
          <div id="navigation-menu" className="navigation-menu">
            <ul className="navigation-links">
              <li className="navigation-item">
                <a href="/#calculatorSection" onClick={(e) => {
                  const calculatorElement = document.getElementById('calculatorSection');
                  if (calculatorElement) {
                    e.preventDefault();
                    // Get the header height for offset calculation
                    const header = document.querySelector('.navigation');
                    const headerHeight = header ? header.offsetHeight : 80;

                    // Get calculator position and dimensions
                    const rect = calculatorElement.getBoundingClientRect();
                    const absoluteTop = rect.top + window.pageYOffset;

                    // Center calculator in visible viewport (accounting for header)
                    // Add 110px offset to scroll a bit more down
                    const visibleHeight = window.innerHeight - headerHeight;
                    const scrollPosition = absoluteTop - headerHeight - (visibleHeight / 2) + (rect.height / 2) + 110;

                    window.scrollTo({
                      top: Math.max(0, scrollPosition),
                      behavior: 'smooth'
                    });
                  }
                }}>
                  <div className="navigation-link">
                    <span>{t('navigation.frameCalculator')}</span>
                  </div>
                </a>
              </li>
              <li className="navigation-item">
                <a href="/about">
                  <div className="navigation-link">
                    <span>{t('navigation.about')}</span>
                  </div>
                </a>
              </li>
              <li className="navigation-item">
                <a href="/contact">
                  <div className="navigation-link">
                    <span>{t('navigation.contact')}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div className="navigation-actions">
            <LanguageSwitcher />
            <button
              type="button"
              aria-label={t('navigation.userAccount')}
              className="navigation-action-btn"
            >
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                className="navigation-navigation-icon1"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                  <circle r="4" cx="12" cy="7"></circle>
                </g>
              </svg>
            </button>
            <button
              type="button"
              aria-label={t('navigation.shoppingCart')}
              className="navigation-action-btn"
            >
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                className="navigation-navigation-icon2"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle r="1" cx="8" cy="21"></circle>
                  <circle r="1" cx="19" cy="21"></circle>
                  <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
                </g>
              </svg>
              <span
                id="cart-badge"
                className="navigation-navigation-cart-badge"
              >
                0
              </span>
            </button>
          </div>
          <button
            id="navigation-toggle"
            type="button"
            aria-label={t('navigation.menu')}
            className="navigation-toggle"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              className="navigation-navigation-menu-icon"
            >
              <path
                d="M4 5h16M4 12h16M4 19h16"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              className="navigation-navigation-close-icon"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
    </div>
  )
}

export default Navigation
